"use client"

import styled from "@emotion/styled"
import { Typography, TypographyProps } from "@mui/material"
import { delayTime, transitionEase, transitionTime } from "./transitions/utils"

export const AnimatedTypography = styled(Typography)<
  TypographyProps & { $inview: boolean }
>`
  p {
    margin: 0;
  }
  opacity: ${(p) => (p.$inview ? 1 : 0)};
  transition: all ${transitionTime}s ${transitionEase};
  transform: ${(p) => (p.$inview ? "translateX(0px)" : `translateX(-100vw)`)};
  transition-delay: ${delayTime}s;
`
